import { render } from "./logo.vue?vue&type=template&id=9c7258c2"
const script = {}
script.render = render

export default script